// AWS Amplify Configuration Template - autogenerated at deploy time
/* eslint no-template-curly-in-string: 0*/
const config = {
  s3: {
    REGION: "eu-central-1",
    BUCKET: "app-be-advisor-844375376115-uploads",
  },
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://8056ucvfje.execute-api.eu-central-1.amazonaws.com/prod/v1",
  },
  cognito: {
    REGION: "eu-central-1",
    USER_POOL_ID: "eu-central-1_ILzH518GY",
    APP_CLIENT_ID: "4op79pso83sksarc73dp6epb7j",
    IDENTITY_POOL_ID: "eu-central-1:6f5c8a5c-dda1-41eb-9126-f689e06cc048",
  },
  locales: {
    URL: "https://locales.platform.prod.beteiligungsboerse.net",
  },
  datastore: {
    URL: "https://datastore.platform.prod.beteiligungsboerse.net",
  },
  integrations: {
    CALENDLY_TOKEN: "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzAyNjQ0MTc1LCJqdGkiOiI2ZThlMmFiZi1iZTE3LTQxYmItOGJjMy04Y2E2Njc2OWIxMjgiLCJ1c2VyX3V1aWQiOiIzM2IyNWQzYS0wYWU5LTQzMzYtYWQzNy0xMzhlZTdmNmE2MDgifQ.u2HU8CuxDtNUJqFt9-ui853ghWkAkn8hNlZW6CfW70184MS6FllNwMJgNZbcpVHwIj557-TLXqePEifMmBcvCQ",
    CALENDLY_URL: "https://calendly.com/bb-breitkreutz/erstgespraech",
  },
  registration: {
    URL: "https://registration.platform.prod.beteiligungsboerse.net/v1",
    NEXT_PAGE: "https://app.advisor.prod.beteiligungsboerse.net",
    TO_REFERRER: "https://www.beteiligungsboerse.eu/register-success/",
  },
  product: {
    PRODUCT_KEY: "advisor",
  },
};

export default config;
